import "./styles.css";

import { Button, Input } from "@mui/material";
import React, { useEffect, useState } from "react";

import AudioWrapV2 from "../audioWrap/audioWrapV2";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import MicIcon from "@mui/icons-material/Mic";
import VideocamIcon from "@mui/icons-material/Videocam";

const FilesUploadModel = ({ label, schema, handleChange }) => {
  const [isVideoOn, setVideoOn] = useState(false);
  const [isAudioOn, setAudioOn] = useState(false);
  const [cameraShow, setCameraShow] = useState(false);
  const [videoShow, setVideoShow] = useState(false);
  const [audioShow, setAudioShow] = useState(false);
  const [fileShow, setFileShow] = useState(false);
  const [extraInfo, setExtraInfo] = useState("");

  useEffect(() => {
    if (!window.__CAMERA_HANDLERS__) {
      window.__CAMERA_HANDLERS__ = {};
    }

    window.__CAMERA_HANDLERS__[schema.path] = handleChange;

    return () => {
      delete window.__CAMERA_HANDLERS__[schema.path];
    };
  }, [handleChange, schema.path]);
  
  const handleCameraButtonClick = (fieldId) => {
    if (window?.ReactNativeWebView?.postMessage) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "OPEN_CAMERA",
          fieldId: fieldId,
        })
      );
    } else {
      // fallback browser camera
      document.getElementById(`cameraInput_${fieldId}`).click();
    }
  };

  const toggleVideo = () => {
    setVideoOn((prev) => !prev);
  };

  const toggleAudio = () => {
    setAudioOn((prev) => !prev);
  };

  const handleVideoButtonClick = () => {
    document.getElementById(`videoInput_${schema?.path}`).click();
  };

  useEffect(() => {
    setCameraShow(schema?.media === "camera");
    setVideoShow(schema?.media === "video");
    setAudioShow(schema?.media === "audio");
    setFileShow(schema?.media === "file");
    setExtraInfo(schema?.extraInfo);
  }, [schema]);

  const handleFileInputChange = (event) => {
    const selectedFiles = event.target.files;

    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];
      const fileName = file.name;
      const fileExtension = fileName.split(".").pop();

      const uniqueFile = new File(
        [file],
        `${fileName.replace(/\.[^/.]+$/, "")}_${Date.now()}.${fileExtension}`,
        { type: file.type }
      );

      handleChange({
        file: uniqueFile,
        metadata: {
          type: uniqueFile.type,
          size: uniqueFile.size,
        },
      });
    }
  };

  return (
    <div className="filesUploadModel" id={`${schema?.path}`}>
      <div className="heading">
        {label}
        {schema?.file_required && <span>*</span>}
      </div>

      {extraInfo && (
        <div className="subheading">
          {extraInfo?.map((info, index) => (
            <p key={index}>{info}</p>
          ))}
        </div>
      )}

      <div>
        {cameraShow && (
          <>
            <Button
              onClick={() => handleCameraButtonClick(schema.path)}
              variant="contained"
              startIcon={<CameraAltIcon />}
              style={{ width: "100%", marginBottom: 10 }}
            >
              Capture Photo (App)
            </Button>

            {/* <Button
              onClick={() =>
                document.getElementById(`cameraInput_${schema?.path}`).click()
              }
              variant="outlined"
              style={{ width: "100%" }}
            >
              Use Browser Camera
            </Button> */}

            <Input
              type="file"
              inputProps={{ accept: "image/*", capture: "environment" }}
              onChange={handleFileInputChange}
              id={`cameraInput_${schema?.path}`}
              style={{ display: "none" }}
            />
          </>
        )}

        {fileShow && (
          <>
            <Button
              onClick={() =>
                document.getElementById(`cameraInput_${schema?.path}`).click()
              }
              variant="contained"
              startIcon={<FileUploadIcon />}
              style={{
                width: "100%",
                textTransform: "none",
                marginBottom: "10px",
              }}
            >
              Upload Files
            </Button>

            <Input
              type="file"
              inputProps={{ accept: "image/*", multiple: true }}
              onChange={handleFileInputChange}
              id={`cameraInput_${schema?.path}`}
              style={{ display: "none" }}
            />
          </>
        )}

        {videoShow && (
          <>
            <Button
              onClick={handleVideoButtonClick}
              variant="contained"
              color="primary"
              startIcon={<VideocamIcon />}
              style={{
                width: "100%",
                textTransform: "none",
                marginBottom: "10px",
              }}
            >
              Capture Video
            </Button>
            <Input
              type="file"
              inputProps={{ accept: "video/*", capture: "environment" }}
              onChange={handleFileInputChange}
              id={`videoInput_${schema?.path}`}
              style={{ display: "none" }}
            />
          </>
        )}

        {audioShow && (
          <Button
            onClick={toggleAudio}
            variant="contained"
            color="primary"
            startIcon={<MicIcon />}
            style={{ width: "100%", textTransform: "none" }}
          >
            Record Audio
          </Button>
        )}
      </div>
    </div>
  );
};

export default FilesUploadModel;